var _rect, _rect2, _rect3, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasaError3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130mm",
    height: "110mm",
    viewBox: "0 0 130 110",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154.97473,
    y: 120.07051,
    width: 224.78317,
    height: 258.29123,
    id: "rect8313"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120.07051,
    y: 124.25902,
    width: 231.76402,
    height: 223.38699,
    id: "rect8028"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 487.26291,
    y: 185.69044,
    width: 92.243019,
    height: 164.74791,
    id: "rect8022"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style1685"
  }, ".cls-1{fill:#ff4c22;}.cls-2{fill:#fff7e9;}")), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath496"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#f0582c",
      strokeWidth: 1.72694,
      strokeOpacity: 0.925278,
      paintOrder: "markers stroke fill"
    },
    id: "rect499",
    width: 131.72331,
    height: 111.79354,
    x: 27.61318,
    y: 105.00857,
    ry: 15.283369
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g507",
    transform: "translate(-27.61318,-105.00857)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fd6a00",
      strokeWidth: 4.50501,
      strokeOpacity: 1,
      paintOrder: "markers stroke fill"
    },
    id: "path542",
    d: "m 69.817162,231.98506 c -2.281934,2.87801 -16.77618,-0.53804 -20.361123,-1.337 -3.973876,-0.88565 -19.68797,-4.13626 -21.186054,-7.922 -1.351462,-3.41521 8.854044,-14.25958 11.338439,-16.96475 2.753929,-2.99865 13.426088,-14.98215 17.453675,-14.38666 3.633396,0.53721 7.922136,14.79762 9.022684,18.30175 1.219948,3.8843 6.261882,19.11841 3.732379,22.30866 z",
    transform: "matrix(1.2286683,-0.25807299,0.29235876,1.0845788,0.37837551,-27.170094)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 7.34525,
      paintOrder: "markers stroke fill"
    },
    id: "rect552",
    width: 29.182835,
    height: 39.156715,
    x: 93.089554,
    y: 151.08582
  }), /*#__PURE__*/React.createElement("image", {
    width: 105.83334,
    height: 82.550003,
    preserveAspectRatio: "none",
    id: "image442",
    x: 27.61318,
    y: 105.00857,
    style: {
      fill: "#ff4c22",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g8309",
    transform: "matrix(1.0339534,0,0,0.92407932,-4.3123941,17.368513)",
    style: {
      fill: "#ff6600"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff6600",
      stroke: "#fd6a00",
      strokeWidth: 4.42437,
      paintOrder: "markers stroke fill"
    },
    id: "rect8303",
    width: 1.1888472,
    height: 16.606485,
    x: 126.41488,
    y: 173.89734,
    ry: 0.49819452
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#ff6600",
      stroke: "#fd6a00",
      strokeWidth: 4.50501,
      paintOrder: "markers stroke fill"
    },
    id: "path8305",
    cx: 127.00931,
    cy: 198.18469,
    rx: 1.4776119,
    ry: 2.0317163
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasaError3);
export default __webpack_public_path__ + "static/media/CasaError3.b11e9c162a0495a7d602a2762e9c1b46.svg";
export { ForwardRef as ReactComponent };